import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragDropContainer } from "react-drag-drop-container";
import "./style.css";

const ArticleIntrastatRow = ({
  article,
  contoId,
  droppingOn,
  onArticleDrag,
  allowDrag,
  setAllowDrag,
  lockDrag,
  setLockDrag,
  setDraggingFrom,
  draggingFrom
}) => {

  const [dropData, setDropData] = useState({});

  useEffect(() => {
    if (!lockDrag) {
      setAllowDrag(false);
    }
  }, [lockDrag]);

  useEffect(() => {
    if (draggingFrom) {
      setDropData({ ...dropData, from: draggingFrom });
    }
  }, [draggingFrom]);

  return (
    // <DropTarget targetKey="precog-articles-drag"></DropTarget>
    <DragDropContainer noDragging={!lockDrag && !allowDrag} onDragStart={() => { setLockDrag(true); setDraggingFrom(contoId); }} onDragEnd={() => { setLockDrag(false); onArticleDrag({ ...dropData, to: droppingOn, article: article }); }} targetKey="precog-intrastat-articles-drag" dragData={{ rowId: contoId }}>
      <>
        <div
          className={"articles-intrastat-accordion" + (!allowDrag ? " noDragging" : "")}
          style={{ paddingLeft: "14px" }}
          onMouseEnter={() => setAllowDrag(true)}
          onMouseLeave={() => { if (!lockDrag) { setAllowDrag(false); } }}
        >
          <div style={{ width: "40%" }}>
            {article.articleDesc}
          </div>
          <div style={{ width: "59%" }}>{`${article.totale} €`}</div>
          <div
            className="articles-intrastat-row-grip-lines"
            style={{ width: "1%" }}
          >
            <FontAwesomeIcon
              icon={["far", "grip-lines"]}
            />
          </div>
        </div>
      </>
    </DragDropContainer>
  );
};

export default ArticleIntrastatRow;
